import { FlagCircleRounded } from "@mui/icons-material";

export const flagRounded = (props) => {
  return <FlagCircleRounded {...props} />;
};
